import { render } from "./LinkSupplierInvoiceToInvoice.vue?vue&type=template&id=1a6beba4"
import script from "./LinkSupplierInvoiceToInvoice.vue?vue&type=script&lang=js"
export * from "./LinkSupplierInvoiceToInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__